webpackJsonp([114276838955818],{

/***/ 335:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Priority Construction","desc":"Priority Construction Corp. is dedicated to complete different types of concrete projects throughout the Baltimore area by using highly skilled employees and paying attention to every detail of the project.","keywords":["construction","Baltimore","Maryland","concrete","brick","flatwork"],"address":{"streetAddress":"1315 West Hamburg Street","state":"MD","city":"Baltimore","zip":21230},"phone":"410-244-6773"}},"backgroundHome":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAgQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAZaIGDDV/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQIRAAMS/9oACAEBAAEFAkbdGEq4dDPeL0//xAAXEQADAQAAAAAAAAAAAAAAAAAAARIC/9oACAEDAQE/AZySj//EABcRAAMBAAAAAAAAAAAAAAAAAAABEgL/2gAIAQIBAT8BrRTP/8QAGBAAAwEBAAAAAAAAAAAAAAAAABAyATH/2gAIAQEABj8CknSVxf/EABoQAAMBAAMAAAAAAAAAAAAAAAABESExUWH/2gAIAQEAAT8hWlKvg+u3eHLWMiKGNSDqRH//2gAMAwEAAgADAAAAECfP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxAn/8QAFREBAQAAAAAAAAAAAAAAAAAAEGH/2gAIAQIBAT8QsH//xAAdEAACAgIDAQAAAAAAAAAAAAABEQAhMVFBYbHh/9oACAEBAAE/EFklg21BPSyKIa+xZtWUiMSwk9QPREcgmFhO6E//2Q==","aspectRatio":1.4998848191660907,"src":"/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-8641c.jpg","srcSet":"/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-d7db7.jpg 375w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-7b8e8.jpg 750w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-8641c.jpg 1500w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-66a78.jpg 2250w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-d14a5.jpg 3000w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-2e4ee.jpg 4500w,\n/static/Fells-20-b1255d590e6a04e2220e54b4fa92b418-a2e3d.jpg 6511w","sizes":"(max-width: 1500px) 100vw, 1500px"}},"backgroundAbout":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAaABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAIDBQQG/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAABsjwDUPNjnb5MszdRSn//xAAdEAACAgEFAAAAAAAAAAAAAAABAgMSEQAQITEz/9oACAEBAAEFAuNFjVGFHFIx5y5s7JgzKpmYOx7G3//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/ASn/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwFVV//EAB0QAAICAgMBAAAAAAAAAAAAAAABEUECISAiMYH/2gAIAQEABj8CbxHBjuhxpG36fEdmWyUqvh//xAAeEAACAgICAwAAAAAAAAAAAAABEQAhMUEQYVGRsf/aAAgBAQABPyEAaJVNw9BEDzLULTcWhQlAPoD1KBG/lHgCOohMWWBB2oQyUtbggdT/2gAMAwEAAgADAAAAEOjS/P/EABcRAQEBAQAAAAAAAAAAAAAAAAARAUH/2gAIAQMBAT8Q61SP/8QAGhEBAAEFAAAAAAAAAAAAAAAAABEBITFBUf/aAAgBAgEBPxDSXEsqWP/EAB4QAQADAAICAwAAAAAAAAAAAAEAESExQVGRYXHB/9oACAEBAAE/EKAnUEa3pcX2Qd7fTLwFIiDa2B0eBrb3INKPIN1BfEEVYdT8gKKIobfjIQ8DWvUC60Fq9DEoq1XWch78zuBrCyf/2Q==","aspectRatio":0.773492286115007,"src":"/static/pigtown-crop2-5c4531189909282de3575911c3525c10-8641c.jpg","srcSet":"/static/pigtown-crop2-5c4531189909282de3575911c3525c10-d7db7.jpg 375w,\n/static/pigtown-crop2-5c4531189909282de3575911c3525c10-7b8e8.jpg 750w,\n/static/pigtown-crop2-5c4531189909282de3575911c3525c10-8641c.jpg 1500w,\n/static/pigtown-crop2-5c4531189909282de3575911c3525c10-7e8bd.jpg 2206w","sizes":"(max-width: 1500px) 100vw, 1500px"}},"backgroundServices":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAH/2gAMAwEAAhADEAAAAUtMsGyFhX//xAAbEAADAAIDAAAAAAAAAAAAAAABAgMABBITIf/aAAgBAQABBQKTmbFELc2QHSXJy6g1Pf/EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AUf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAeEAABBAEFAAAAAAAAAAAAAAABAAIREgMQMTJxof/aAAgBAQAGPwKQhkGx9VWtLh2uZUWkaf/EABwQAQADAAIDAAAAAAAAAAAAAAEAETFRYXGx0f/aAAgBAQABPyERf2dRUeYMgKC8fSC+EsA9qTI+bPE//9oADAMBAAIAAwAAABB3D//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxANj//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8Q1FR//8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFR0WH/2gAIAQEAAT8QNig114l5gRxRu6TowdcaxR41A6K6zjn7uI/RoMt0haI+I8n/2Q==","aspectRatio":1.4478577202910268,"src":"/static/anthem-house-plants-sidewalk-crop2-3259604fedc6ad3d0055a5196de80af3-8641c.jpg","srcSet":"/static/anthem-house-plants-sidewalk-crop2-3259604fedc6ad3d0055a5196de80af3-d7db7.jpg 375w,\n/static/anthem-house-plants-sidewalk-crop2-3259604fedc6ad3d0055a5196de80af3-7b8e8.jpg 750w,\n/static/anthem-house-plants-sidewalk-crop2-3259604fedc6ad3d0055a5196de80af3-8641c.jpg 1500w,\n/static/anthem-house-plants-sidewalk-crop2-3259604fedc6ad3d0055a5196de80af3-8366b.jpg 1791w","sizes":"(max-width: 1500px) 100vw, 1500px"}},"backgroundGallery":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEBQL/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAYNWJyIOQVWZXRq0zyv/xAAcEAACAwADAQAAAAAAAAAAAAABAgADERASIUL/2gAIAQEAAQUCqrLEqFjWLq6R87XEbCLfWZd2duP/xAAZEQACAwEAAAAAAAAAAAAAAAAAEQEQEhP/2gAIAQMBAT8ByznFM//EABkRAAEFAAAAAAAAAAAAAAAAAAABEBESE//aAAgBAgEBPwG0Giv/AP/EAB0QAAECBwAAAAAAAAAAAAAAAAEAEAIREiAhIjH/2gAIAQEABj8CUy2EahEuFtrf/8QAGhABAQEBAQEBAAAAAAAAAAAAAQARITGRof/aAAgBAQABPyHgIH6yHmhPi8Dwtz9Baw3pB2NJDQ5bhEvb/9oADAMBAAIAAwAAABA8303/xAAZEQACAwEAAAAAAAAAAAAAAAAAAREhUWH/2gAIAQMBAT8QutnQlEMP/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQIWH/2gAIAQIBAT8QGMJzrZ//xAAcEAEBAQACAwEAAAAAAAAAAAABEQAhMUFhwVH/2gAIAQEAAT8QJgaR6p6urQYXhxcwDwCZJELVeuurmUwr385ZYPmg/NRCDWbL8wAhNJixzx63Ac5VO//Z","aspectRatio":0.6666666666666666,"src":"/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-8641c.jpg","srcSet":"/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-d7db7.jpg 375w,\n/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-7b8e8.jpg 750w,\n/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-8641c.jpg 1500w,\n/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-66a78.jpg 2250w,\n/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-d14a5.jpg 3000w,\n/static/Fells-19-c2bf1a9834fbdb9293fe019c8d976222-a391a.jpg 4480w","sizes":"(max-width: 1500px) 100vw, 1500px"}},"backgroundCareers":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAABgqazucuS/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQIDEgAx/9oACAEBAAEFAkjoZHDydCgiumquW//EABYRAQEBAAAAAAAAAAAAAAAAABEAAf/aAAgBAwEBPwFJy//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AQZ//8QAHBAAAgEFAQAAAAAAAAAAAAAAAAEhAhARIkFR/9oACAEBAAY/AnPRpTarHpJqz//EABoQAQEBAQEBAQAAAAAAAAAAAAERACExQVH/2gAIAQEAAT8hj0Rqr3TiCe/mEADMgQr9dw38Ts3HSS93/9oADAMBAAIAAwAAABBDL//EABcRAAMBAAAAAAAAAAAAAAAAAAABETH/2gAIAQMBAT8QVimM/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARMf/aAAgBAgEBPxBC7yxL/8QAHBABAAMAAwEBAAAAAAAAAAAAAQARIUFRkaHw/9oACAEBAAE/EFPGyEVxV0G8wCMhZGwPD3BAwwE2D6i04rr5FSUk0UrXh5EIpigt/ZP/2Q==","aspectRatio":1.5,"src":"/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-8641c.jpg","srcSet":"/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-d7db7.jpg 375w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-7b8e8.jpg 750w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-8641c.jpg 1500w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-66a78.jpg 2250w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-d14a5.jpg 3000w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-2e4ee.jpg 4500w,\n/static/PriorityShovel-01261fcb1b8e374710b301354c138e18-b9a96.jpg 4608w","sizes":"(max-width: 1500px) 100vw, 1500px"}},"backgroundRequestQuote":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAE/GoE8qK//xAAZEAADAAMAAAAAAAAAAAAAAAAAAQIRITH/2gAIAQEAAQUCmsFUydiR1JH/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEiH/2gAIAQMBAT8Blj//xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAIAQIBAT8Bq6//xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIhEBEycf/aAAgBAQAGPwLcU34cyzZVH//EABwQAQACAgMBAAAAAAAAAAAAAAEAMREhQWGBsf/aAAgBAQABPyFHABWXkyDdwziawbHcAPhP/9oADAMBAAIAAwAAABBEz//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAwEBPxAGZAC//8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EF7sx//EABsQAQEBAQADAQAAAAAAAAAAAAERACExQVHR/9oACAEBAAE/ELIRw9sRbHlRzBoDERM1QU/LggrIzo5mkQtT63//2Q==","aspectRatio":1.5,"src":"/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-8641c.jpg","srcSet":"/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-d7db7.jpg 375w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-7b8e8.jpg 750w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-8641c.jpg 1500w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-66a78.jpg 2250w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-d14a5.jpg 3000w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-2e4ee.jpg 4500w,\n/static/CoppinState-2-77401018055d3adac5caaf7fab5ce0d1-1d5d1.jpg 5499w","sizes":"(max-width: 1500px) 100vw, 1500px"}}},"layoutContext":{}}

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(405);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(335);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(330);
	var isArguments = __webpack_require__(329);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	'use strict';
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	  return a === b;
	};
	
	function index (resultFn, isEqual) {
	  if (isEqual === void 0) {
	    isEqual = simpleIsEqual;
	  }
	
	  var lastThis;
	  var lastArgs = [];
	  var lastResult;
	  var calledOnce = false;
	
	  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	    return isEqual(newArg, lastArgs[index]);
	  };
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	      return lastResult;
	    }
	
	    lastResult = resultFn.apply(this, newArgs);
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    return lastResult;
	  };
	
	  return result;
	}
	
	module.exports = index;


/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(343);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(328);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(339);
	
	var _HelmetConstants = __webpack_require__(268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(300);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(332));
	var shallowEqual = _interopDefault(__webpack_require__(345));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Button = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border: 1px solid\n    ', ';\n  font-weight: ', ';\n  background-color: ', ';\n  border-radius: 2px;\n  text-transform: uppercase;\n  ', ';\n  transition: background-color 0.2s;\n  min-height: ', ';\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n    background-color: ', ';\n  }\n\n  ', ';\n\n  &:disabled {\n    pointer-events: none;\n    border-color: ', ';\n    color: ', ';\n    background-color: ', ';\n  }\n'], ['\n  border: 1px solid\n    ', ';\n  font-weight: ', ';\n  background-color: ', ';\n  border-radius: 2px;\n  text-transform: uppercase;\n  ', ';\n  transition: background-color 0.2s;\n  min-height: ', ';\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n    background-color: ', ';\n  }\n\n  ', ';\n\n  &:disabled {\n    pointer-events: none;\n    border-color: ', ';\n    color: ', ';\n    background-color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var Tag = _ref.tag,
	      color = _ref.color,
	      large = _ref.large,
	      rest = _objectWithoutProperties(_ref, ['tag', 'color', 'large']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	exports.Button = Button;
	Button.propTypes = {
	  tag: CustomPropTypes.Tag,
	  color: _propTypes2.default.oneOf(['light']),
	  large: _propTypes2.default.bool
	};
	
	Button.defaultProps = {
	  tag: 'button'
	};
	
	Button.displayName = 'Button';
	
	exports.default = (0, _styledComponents2.default)(Button)(_templateObject, (0, _tinycolor2.default)(_vars.COLORS.base).lighten(20).toRgbString(), _vars.BODY_WEIGHTS.medium, _vars.COLORS.bg, function (_ref2) {
	  var large = _ref2.large;
	  return large ? 'padding: ' + (0, _utils.pxToRem)(12) + ' ' + (0, _utils.pxToRem)(24) : 'padding: ' + (0, _utils.pxToRem)(8) + ' ' + (0, _utils.pxToRem)(24);
	}, (0, _utils.pxToRem)(38), _vars.COLORS.base, (0, _tinycolor2.default)(_vars.COLORS.bg).darken(10).setAlpha(0.5).toRgbString(), function (_ref3) {
	  var color = _ref3.color;
	
	  switch (color) {
	    case 'light':
	      return '\n          background-color: ' + _vars.COLORS.brand[1] + ';\n          border-color: ' + _vars.COLORS.brand[1] + ';\n          color: ' + _vars.COLORS.base + ';\n\n          &:hover,\n          &:focus {\n            background-color: ' + (0, _tinycolor2.default)(_vars.COLORS.brand[1]).lighten(7).toRgbString() + ';\n            border-color: ' + _vars.COLORS.brand[1] + ';\n          }\n        ';
	    default:
	      return '';
	  }
	}, (0, _tinycolor2.default)(_vars.COLORS.muted).lighten(30).toRgbString(), _vars.COLORS.muted, (0, _tinycolor2.default)(_vars.COLORS.muted).lighten(40).toRgbString());

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CloseIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CloseIcon = exports.CloseIcon = function CloseIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '-6.125 9.875 13.25 13.25' }, props),
	    _react2.default.createElement('path', {
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round',
	      d: 'M-5.102,22.12L6.102,10.916 '
	    }),
	    _react2.default.createElement('path', {
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round',
	      d: 'M6.102,22.12L-5.102,10.916 '
	    })
	  );
	};
	
	CloseIcon.displayName = 'CloseIcon';
	
	exports.default = (0, _styledComponents2.default)(CloseIcon)(_templateObject);

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatList = (0, _styledComponents2.default)(_List2.default)(_templateObject);
	
	exports.default = FlatList;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n'], ['\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlatListItem = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject);
	
	exports.default = FlatListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Footer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ' ', ';\n  background-color: ', ';\n\n  &,\n  a {\n    color: #fff;\n\n    &::after {\n      background-color: rgba(255, 255, 255, 0.3);\n      z-index: 0;\n    }\n  }\n'], ['\n  padding: ', ' ', ';\n  background-color: ', ';\n\n  &,\n  a {\n    color: #fff;\n\n    &::after {\n      background-color: rgba(255, 255, 255, 0.3);\n      z-index: 0;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 1rem;\n\n  ', ' {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: ', ';\n  }\n\n  ', ' {\n    margin-bottom: 0;\n    padding-right: ', ';\n\n    &:not(:last-child)::after {\n      content: \'\xB7\';\n      display: inline-block;\n      padding-left: 0.5rem;\n    }\n  }\n\n  ', ':last-child {\n    padding-right: 0;\n  }\n'], ['\n  margin-bottom: 1rem;\n\n  ', ' {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: ', ';\n  }\n\n  ', ' {\n    margin-bottom: 0;\n    padding-right: ', ';\n\n    &:not(:last-child)::after {\n      content: \'\xB7\';\n      display: inline-block;\n      padding-left: 0.5rem;\n    }\n  }\n\n  ', ':last-child {\n    padding-right: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  line-height: ', ';\n\n  ', ' {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  ', ' {\n    display: inline-flex;\n  }\n'], ['\n  font-size: ', ';\n  line-height: ', ';\n\n  ', ' {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  ', ' {\n    display: inline-flex;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Container = __webpack_require__(119);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _utils = __webpack_require__(6);
	
	var _vars = __webpack_require__(5);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _links = __webpack_require__(139);
	
	var _links2 = _interopRequireDefault(_links);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundContainer = (0, _styledComponents2.default)(_Container2.default)(_templateObject, (0, _utils.pxToRem)(40), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), _vars.COLORS.brand[4]);
	
	var Address = _styledComponents2.default.address(_templateObject2, _List2.default, (0, _utils.pxToRem)(4), _ListItem2.default, (0, _utils.pxToRem)(8), _ListItem2.default);
	
	var Footer = function Footer(props) {
	  var Tag = props.tag,
	      streetAddress = props.streetAddress,
	      city = props.city,
	      state = props.state,
	      zip = props.zip,
	      phone = props.phone,
	      rest = _objectWithoutProperties(props, ['tag', 'streetAddress', 'city', 'state', 'zip', 'phone']);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    _react2.default.createElement(
	      BackgroundContainer,
	      { plus: true },
	      _react2.default.createElement(
	        Address,
	        null,
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          _react2.default.createElement(
	            _ListItem2.default,
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.google.com/maps/place/1315+W+Hamburg+St,+Baltimore,+MD+21230/' },
	              streetAddress,
	              ' ',
	              city,
	              ', ',
	              state,
	              ' ',
	              zip
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          _react2.default.createElement(
	            _ListItem2.default,
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + phone },
	              'phone: ',
	              phone
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          _links2.default.filter(function (link) {
	            return link.footer;
	          }).map(function (link) {
	            return _react2.default.createElement(
	              _ListItem2.default,
	              { key: link.to },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: link.to },
	                link.children
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.Footer = Footer;
	Footer.displayName = 'Footer';
	
	Footer.propTypes = {
	  tag: CustomPropTypes.Tag,
	  streetAddress: _propTypes2.default.string.isRequired,
	  city: _propTypes2.default.string.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  zip: _propTypes2.default.number.isRequired,
	  phone: _propTypes2.default.string.isRequired
	};
	
	Footer.defaultProps = {
	  tag: 'footer'
	};
	
	exports.default = (0, _styledComponents2.default)(Footer)(_templateObject3, (0, _utils.pxToRem)(_vars.TYPE_SIZE.small[0]), _vars.TYPE_SIZE.small[1], Address, _List2.default);

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(338);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _appleTouchIcon = __webpack_require__(346);
	
	var _appleTouchIcon2 = _interopRequireDefault(_appleTouchIcon);
	
	var _favicon32x = __webpack_require__(348);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _favicon16x = __webpack_require__(347);
	
	var _favicon16x2 = _interopRequireDefault(_favicon16x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Head = function Head(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      keywords = _ref.keywords;
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement('html', { lang: 'en' }),
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('meta', { name: 'description', content: description }),
	    _react2.default.createElement('meta', { name: 'keywords', content: keywords }),
	    _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: _appleTouchIcon2.default }),
	    _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: _favicon32x2.default }),
	    _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: _favicon16x2.default })
	  );
	};
	
	Head.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  keywords: _propTypes2.default.string
	};
	
	Head.displayName = 'Head';
	
	exports.default = Head;
	module.exports = exports['default'];

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  margin: 0 auto;\n  max-width: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: 1.25rem ', ';\n  position: sticky;\n  top: -1px;\n  z-index: 10;\n  transition: background-color 0.3s;\n\n  @media (min-width: ', ') {\n    padding-top: 2rem;\n  }\n\n  &[data-stuck=\'true\'] {\n    background-color: ', ';\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  }\n'], ['\n  background-color: ', ';\n  padding: 1.25rem ', ';\n  position: sticky;\n  top: -1px;\n  z-index: 10;\n  transition: background-color 0.3s;\n\n  @media (min-width: ', ') {\n    padding-top: 2rem;\n  }\n\n  &[data-stuck=\'true\'] {\n    background-color: ', ';\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _utils = __webpack_require__(6);
	
	var _vars = __webpack_require__(5);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeaderBarContent = _styledComponents2.default.div(_templateObject, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH));
	
	var HeaderBar = function (_React$Component) {
	  _inherits(HeaderBar, _React$Component);
	
	  function HeaderBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeaderBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { stuck: false }, _this.handleScroll = function () {
	      if (window.pageYOffset > 0 && _this.state.stuck === false) {
	        _this.setState({ stuck: true });
	      } else if (window.pageYOffset === 0 && _this.state.stuck === true) {
	        _this.setState({ stuck: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HeaderBar.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll, false);
	  };
	
	  HeaderBar.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll, false);
	  };
	
	  HeaderBar.prototype.render = function render() {
	    var _props = this.props,
	        Tag = _props.tag,
	        innerRef = _props.innerRef,
	        children = _props.children,
	        rest = _objectWithoutProperties(_props, ['tag', 'innerRef', 'children']);
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({}, rest, { 'data-stuck': this.state.stuck, ref: innerRef }),
	      _react2.default.createElement(
	        HeaderBarContent,
	        null,
	        children
	      )
	    );
	  };
	
	  return HeaderBar;
	}(_react2.default.Component);
	
	HeaderBar.displayName = 'HeaderBar';
	
	HeaderBar.propTypes = {
	  tag: CustomPropTypes.Tag,
	  children: _propTypes2.default.node,
	  innerRef: _propTypes2.default.func
	};
	
	HeaderBar.defaultProps = {
	  tag: 'header'
	};
	
	exports.default = (0, _styledComponents2.default)(HeaderBar)(_templateObject2, (0, _tinycolor2.default)(_vars.COLORS.bg).setAlpha(0.7).toRgbString(), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.max), _vars.COLORS.bg);
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n'], ['\n  transition: opacity 0.5s;\n  width: 100%;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n'], ['\n  background-color: ', ';\n  overflow: visible;\n  position: relative;\n  max-width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  @media (min-height: ', ') {\n    height: ', ';\n  }\n  max-height: ', ';\n\n  .gatsby-image-outer-wrapper {\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(127);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var Hero = exports.Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function (prevProps) {
	      var isFullHeight = _this.props.isFullHeight;
	
	      if (isFullHeight !== prevProps.isFullHeight && _this.elm && _this.elm.animate) {
	        if (isFullHeight) {
	          _this.elm.animate([{ height: '20vh' }, { height: '70vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        } else {
	          _this.elm.animate([{ height: '70vh' }, { height: '20vh' }], {
	            duration: 300,
	            fill: 'forwards',
	            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	            iterations: 1
	          });
	        }
	      }
	    }, _this.setRef = function (elm) {
	      // eslint-disable-next-line react/no-find-dom-node
	      _this.elm = _reactDom2.default.findDOMNode(elm);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Hero.prototype.render = function render() {
	    var _props = this.props,
	        bgColor = _props.bgColor,
	        selectedImage = _props.selectedImage,
	        bgImages = _props.bgImages,
	        isFullHeight = _props.isFullHeight,
	        children = _props.children,
	        opacity = _props.opacity,
	        imgStyle = _props.imgStyle,
	        Tag = _props.tag,
	        rest = _objectWithoutProperties(_props, ['bgColor', 'selectedImage', 'bgImages', 'isFullHeight', 'children', 'opacity', 'imgStyle', 'tag']);
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({ ref: this.setRef }, rest),
	      children,
	      bgImages.map(function (image) {
	        return _react2.default.createElement(BackgroundImage, {
	          key: image.sizes.src,
	          style: {
	            opacity: selectedImage.sizes.src === image.sizes.src ? '1' : '0'
	          },
	          sizes: image.sizes,
	          opacity: opacity,
	          imgStyle: imgStyle
	        });
	      })
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	Hero.displayName = 'Hero';
	Hero.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  children: _propTypes2.default.node,
	  isFullHeight: _propTypes2.default.bool,
	  selectedImage: CustomPropTypes.ImageSharp.isRequired,
	  bgColor: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  bgImages: _propTypes2.default.arrayOf(CustomPropTypes.ImageSharp),
	  imgStyle: _propTypes2.default.shape({
	    objectPosition: _propTypes2.default.string
	  })
	};
	Hero.defaultProps = {
	  tag: 'header',
	  bgColor: _vars.COLORS.bg,
	  opacity: 1,
	  bgImages: []
	};
	exports.default = (0, _styledComponents2.default)(Hero)(_templateObject2, function (props) {
	  return props.bgColor;
	}, (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH_PLUS), (0, _utils.pxToRem)(450), function (_ref) {
	  var isFullHeight = _ref.isFullHeight;
	  return isFullHeight ? '70vh' : '20vh';
	}, (0, _utils.pxToRem)(460));

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroContent = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeroContent = function HeroContent(_ref) {
	  var Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	exports.HeroContent = HeroContent;
	HeroContent.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	HeroContent.defaultProps = {
	  tag: 'div'
	};
	
	HeroContent.displayName = 'HeroContent';
	
	exports.default = (0, _styledComponents2.default)(HeroContent)(_templateObject);

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroHomePageContent = exports.StyledContentWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  width: 100%;\n  background-color: ', ';\n  margin: 0;\n  height: calc(100% + ', ');\n  padding: ', ' ', ' ', ';\n\n  @media (min-width: ', ') {\n    width: 75%;\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media (min-width: ', ') {\n    width: 50%;\n  }\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  width: 100%;\n  background-color: ', ';\n  margin: 0;\n  height: calc(100% + ', ');\n  padding: ', ' ', ' ', ';\n\n  @media (min-width: ', ') {\n    width: 75%;\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media (min-width: ', ') {\n    width: 50%;\n  }\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  color: #fff;\n  display: flex;\n  justify-content: flex-end;\n'], ['\n  height: 100%;\n  color: #fff;\n  display: flex;\n  justify-content: flex-end;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _HeroContent = __webpack_require__(120);
	
	var _HeroContent2 = _interopRequireDefault(_HeroContent);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContentWrapper = function ContentWrapper(_ref) {
	  var Tag = _ref.tag,
	      props = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, props);
	};
	
	ContentWrapper.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	ContentWrapper.defaultProps = {
	  tag: 'div'
	};
	
	ContentWrapper.displayName = 'ContentWrapper';
	
	var StyledContentWrapper = exports.StyledContentWrapper = (0, _styledComponents2.default)(ContentWrapper)(_templateObject, (0, _tinycolor2.default)(_vars.COLORS.brand[0]).setAlpha(0.9).toRgbString(), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 2), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.GUTTER_SIZE * 3), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroXL), (0, _utils.pxToRem)(_vars.MAX_CONTENT_WIDTH), (0, _utils.pxToRem)(1 / 12 * _vars.MAX_CONTENT_WIDTH));
	
	var HeroHomePageContent = function HeroHomePageContent(_ref2) {
	  var innerTag = _ref2.innerTag,
	      innerClassName = _ref2.innerClassName,
	      children = _ref2.children,
	      rest = _objectWithoutProperties(_ref2, ['innerTag', 'innerClassName', 'children']);
	
	  return _react2.default.createElement(
	    _HeroContent2.default,
	    rest,
	    _react2.default.createElement(
	      StyledContentWrapper,
	      { tag: innerTag, className: innerClassName },
	      children
	    )
	  );
	};
	
	exports.HeroHomePageContent = HeroHomePageContent;
	HeroHomePageContent.propTypes = {
	  innerTag: CustomPropTypes.Tag,
	  innerClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	HeroHomePageContent.displayName = 'HeroHomePageContent';
	
	exports.default = (0, _styledComponents2.default)(HeroHomePageContent)(_templateObject2);

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-left: ', ';\n  padding-right: ', ';\n  width: 100%;\n  min-height: ', ';\n  height: 33%;\n  padding-bottom: 2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  padding-top: 1rem;\n  text-transform: uppercase;\n  font-weight: 400;\n\n  ', ', ', ' {\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-left: ', ';\n  padding-right: ', ';\n  width: 100%;\n  min-height: ', ';\n  height: 33%;\n  padding-bottom: 2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  padding-top: 1rem;\n  text-transform: uppercase;\n  font-weight: 400;\n\n  ', ', ', ' {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  position: relative;\n  z-index: 2;\n'], ['\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  position: relative;\n  z-index: 2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _HeroContent = __webpack_require__(120);
	
	var _HeroContent2 = _interopRequireDefault(_HeroContent);
	
	var _Type = __webpack_require__(291);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _Type3 = __webpack_require__(71);
	
	var _Type4 = _interopRequireDefault(_Type3);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _propTypes3 = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.hgroup(_templateObject, (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(140), _Type2.default, _Type4.default);
	
	var HeroWithBanner = function HeroWithBanner(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['title', 'subtitle', 'tag']);
	
	  return _react2.default.createElement(
	    Tag,
	    rest,
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _Type2.default,
	        { tag: 'h1', weight: 'medium' },
	        title
	      ),
	      subtitle && _react2.default.createElement(
	        _Type4.default,
	        { tag: 'h2' },
	        subtitle
	      )
	    )
	  );
	};
	
	HeroWithBanner.propTypes = {
	  title: _propTypes2.default.node,
	  subtitle: _propTypes2.default.node,
	  tag: _propTypes3.Tag
	};
	
	HeroWithBanner.defaultProps = {
	  tag: _HeroContent2.default
	};
	
	HeroWithBanner.displayName = 'HeroWithBanner';
	
	exports.default = (0, _styledComponents2.default)(HeroWithBanner)(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Logo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Logo = exports.Logo = function Logo(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 171 38.836' }, props),
	    _react2.default.createElement('path', { fill: '#385072', d: 'M0 0h171v21.025H0z' }),
	    _react2.default.createElement('path', { fill: 'none', stroke: '#385072', strokeWidth: '1.23', d: 'M.615 21.025h169.77v17.196H.615z' }),
	    _react2.default.createElement('path', {
	      fill: '#385072',
	      d: 'M166.819 31.431h-2.729v2.65h2.729v-2.65zm-7.364 2.65v-2.884h1.533c2.664 0 3.848-1.261 3.848-3.256 0-1.905-1.286-3.128-3.951-3.128h-4.466v9.268h3.036zm0-5.045v-2.061h.863c.644 0 1.623.115 1.623.979 0 .799-.516 1.082-1.224 1.082h-1.262zm-9.035 1.815c1.416 0 1.622.398 1.622 1.609 0 .824.078 1.416.155 1.621h3.075V33.8c-.361 0-.322-.412-.322-1.623 0-1.867-.592-2.099-1.569-2.459 1.08-.295 1.555-1.197 1.555-2.266 0-1.802-1.015-2.639-4.104-2.639h-4.376v9.268h3.036v-3.23h.928zm-.928-3.875h1.417c.708 0 1.224.309 1.224.966 0 .645-.503.877-1.442.877h-1.198v-1.843zm-9.19-2.406c-2.883 0-4.852 1.891-4.852 4.8 0 3.154 1.942 4.955 4.852 4.955 2.742 0 4.865-1.775 4.865-4.93 0-2.446-1.557-4.825-4.865-4.825m-.026 2.264c1.34-.039 1.854 1.3 1.854 2.562 0 1.533-.515 2.666-1.829 2.666-1.455 0-1.815-1.48-1.815-2.666 0-1.172.412-2.562 1.79-2.562m-5.78 1.519c-.245-2.381-1.828-3.782-4.66-3.782-2.587 0-4.619 1.864-4.619 4.864 0 3.013 1.853 4.891 4.915 4.891 2.446 0 4.158-1.439 4.428-3.835h-2.922c-.115.89-.579 1.571-1.557 1.571-1.545 0-1.828-1.223-1.828-2.523 0-1.79.644-2.704 1.712-2.704.952 0 1.558.554 1.648 1.519h2.883zm-20.84-3.54h-2.846v9.268h2.909v-2.934l-.117-2.112 3.312 5.046h2.843v-9.268h-2.907v2.947l.115 2.112-3.309-5.059zm-9.1-.243c-2.884 0-4.852 1.891-4.852 4.8 0 3.154 1.942 4.955 4.852 4.955 2.742 0 4.865-1.775 4.865-4.93 0-2.446-1.557-4.825-4.865-4.825m-.026 2.264c1.339-.039 1.854 1.3 1.854 2.562 0 1.533-.516 2.666-1.829 2.666-1.455 0-1.815-1.48-1.815-2.666 0-1.172.412-2.562 1.79-2.562m-6.321-2.021h-3.036v9.268h3.036v-9.268zM85.3 27.245h2.729v6.836h3.036v-6.836h2.729v-2.432H85.3v2.432zm-.851 1.108c-.245-2.381-1.828-3.782-4.66-3.782-2.587 0-4.62 1.864-4.62 4.864 0 3.013 1.853 4.891 4.916 4.891 2.446 0 4.158-1.439 4.428-3.835h-2.922c-.116.89-.579 1.571-1.558 1.571-1.544 0-1.827-1.223-1.827-2.523 0-1.79.643-2.704 1.712-2.704.952 0 1.557.554 1.647 1.519h2.884zM65.064 30.04c0 3.192 1.596 4.285 4.466 4.285 3.077 0 4.453-1.299 4.453-4.271v-5.24h-3.036v5.549c0 1.004-.322 1.699-1.417 1.699-1.249 0-1.429-.785-1.429-1.699v-5.549h-3.037v5.226zm-6.166.811c1.416 0 1.623.398 1.623 1.609 0 .824.077 1.416.154 1.621h3.075V33.8c-.36 0-.322-.412-.322-1.623 0-1.867-.592-2.099-1.569-2.459 1.08-.295 1.556-1.197 1.556-2.266 0-1.802-1.016-2.639-4.105-2.639h-4.376v9.268h3.036v-3.23h.928zm-.928-3.875h1.417c.708 0 1.224.309 1.224.966 0 .645-.503.877-1.443.877H57.97v-1.843zm-12.716.269h2.729v6.836h3.036v-6.836h2.729v-2.432h-8.494v2.432zm-1.082.258c-.219-1.621-1.39-2.933-3.965-2.933-2.317 0-4.015.989-4.015 2.959 0 3.541 5.329 2.575 5.329 3.979 0 .438-.502.682-1.261.682-.296 0-.618-.077-.863-.232-.259-.154-.439-.398-.503-.732h-2.908c.065 1.672 1.66 3.1 4.105 3.1 2.55 0 4.338-1.042 4.338-3.189 0-3.375-5.329-2.512-5.329-3.902 0-.336.296-.528.966-.528.296 0 .566.052.785.167.22.116.387.309.439.631h2.882zm-15.602-2.69h-2.843v9.268h2.907v-2.934l-.115-2.112 3.309 5.046h2.844v-9.268h-2.908v2.947l.116 2.112-3.31-5.059zm-9.1-.243c-2.883 0-4.852 1.891-4.852 4.8 0 3.154 1.943 4.955 4.852 4.955 2.742 0 4.865-1.775 4.865-4.93 0-2.446-1.557-4.825-4.865-4.825m-.026 2.264c1.34-.039 1.855 1.3 1.855 2.562 0 1.533-.515 2.666-1.829 2.666-1.455 0-1.816-1.48-1.816-2.666 0-1.172.413-2.562 1.79-2.562m-5.78 1.519c-.245-2.381-1.828-3.782-4.66-3.782-2.587 0-4.619 1.864-4.619 4.864 0 3.013 1.852 4.891 4.915 4.891 2.446 0 4.158-1.439 4.428-3.835h-2.922c-.116.89-.579 1.571-1.557 1.571-1.545 0-1.828-1.223-1.828-2.523 0-1.79.643-2.704 1.712-2.704.952 0 1.557.554 1.648 1.519h2.883z'
	    }),
	    _react2.default.createElement('path', {
	      fill: '#FFF',
	      d: 'M144.772 4.749v.417c.394.005.783.053 1.169.144.575.144 1.062.395 1.457.752l5.988 5.445v2.41c0 .598-.2.993-.601 1.185s-1.209.296-2.426.312v.417h11.37v-.417c-1.169-.016-1.966-.113-2.39-.292-.425-.179-.637-.58-.637-1.205v-3.018l6.261-5.101c.268-.208.599-.363.993-.464.309-.064.726-.12 1.249-.168v-.417h-7.206v.417c1.057.037 1.74.088 2.049.152.459.096.689.288.689.576 0 .187-.188.475-.562.865-.245.256-.479.472-.704.649l-3.52 2.882h-.041l-4.334-3.939c-.214-.23-.351-.389-.407-.477-.06-.088-.089-.169-.089-.244 0-.171.16-.283.48-.336.319-.054 1.046-.096 2.178-.128v-.417m-32.489 3.307h.945c.203-1.172 1.089-1.973 2.657-2.401.854-.23 2.082-.356 3.685-.377v8.638c0 .598-.211.998-.633 1.198-.422.2-1.273.3-2.555.3v.417h11.69v-.417c-1.335 0-2.213-.098-2.634-.296-.422-.198-.633-.598-.633-1.202V5.278c1.633.021 2.86.147 3.683.377 1.463.418 2.349 1.218 2.658 2.401h.944l-.031-3.307H123.28l-.031 3.307zm-13.067 7.775h11.467v-.417c-1.025 0-1.795-.077-2.307-.232-.512-.155-.769-.461-.769-.921V6.319c0-.488.32-.814.961-.978.384-.096 1.089-.154 2.114-.175v-.417h-11.467v.417c.982.021 1.666.082 2.051.183.63.164.944.487.944.97v7.942c0 .486-.331.814-.993.985-.405.102-1.072.158-2.002.168v.417zm-15.485-5.653V6.006c0-.25.136-.431.408-.54.272-.109.846-.164 1.722-.164 1.612 0 2.722.312 3.331.937.352.368.527.87.527 1.505 0 1.035-.462 1.696-1.385 1.982-.923.285-2.457.436-4.603.452m-8.199 5.653h11.081v-.417c-1.153-.021-1.921-.132-2.306-.332s-.576-.588-.576-1.165v-3.211h.013l7.651 5.125h6.843v-.393c-.299-.01-.55-.036-.752-.076-.203-.04-.396-.124-.577-.252l-6.969-4.668c1.174-.107 2.287-.352 3.338-.736 1.375-.513 2.062-1.215 2.062-2.106 0-1.207-1.312-2.042-3.938-2.506-1.356-.23-3.129-.345-5.317-.345H86.498v.417c1.121.047 1.842.135 2.162.262.479.192.72.603.72 1.235v7.254c0 .609-.202 1.004-.607 1.185-.406.182-1.164.286-2.274.312v.417zM73.175 4.501c-3.438 0-6.246.561-8.424 1.682-2.156 1.104-3.234 2.516-3.234 4.235 0 1.559 1.03 2.888 3.09 3.988 2.21 1.169 5.066 1.753 8.568 1.753 3.298 0 6.047-.534 8.247-1.601 2.252-1.095 3.379-2.504 3.379-4.228s-1.127-3.133-3.379-4.228c-2.189-1.067-4.938-1.601-8.247-1.601m-.008 11.106c-2.48 0-4.175-.729-5.084-2.186-.492-.785-.737-1.815-.737-3.091 0-1.254.24-2.274.721-3.059.92-1.478 2.62-2.217 5.1-2.217 1.785 0 3.199.443 4.241 1.329 1.042.886 1.564 2.202 1.564 3.947 0 1.271-.246 2.301-.738 3.091-.92 1.457-2.609 2.186-5.067 2.186m-24.942.224h11.466v-.417c-1.025 0-1.793-.077-2.306-.232-.512-.155-.768-.461-.768-.921V6.319c0-.488.32-.814.96-.978.385-.096 1.089-.154 2.114-.175v-.417H48.225v.417c.982.021 1.666.082 2.05.183.63.164.945.487.945.97v7.942c0 .486-.331.814-.993.985-.406.102-1.073.158-2.002.168v.417zM32.74 10.178V6.006c0-.25.136-.431.409-.54.272-.109.846-.164 1.721-.164 1.612 0 2.722.312 3.331.937.352.368.528.87.528 1.505 0 1.035-.462 1.696-1.385 1.982-.923.285-2.458.436-4.604.452m-8.199 5.653h11.082v-.417c-1.153-.021-1.922-.132-2.306-.332-.385-.2-.577-.588-.577-1.165v-3.211h.014l7.65 5.125h6.844v-.393c-.299-.01-.55-.036-.753-.076s-.395-.124-.577-.252l-6.969-4.668c1.174-.107 2.287-.352 3.338-.736 1.375-.513 2.063-1.215 2.063-2.106 0-1.207-1.313-2.042-3.939-2.506-1.356-.23-3.128-.345-5.317-.345H24.541v.417c1.121.047 1.842.135 2.162.262.48.192.721.603.721 1.235v7.254c0 .609-.203 1.004-.609 1.185-.406.182-1.164.286-2.274.312v.417zm-20.033 0h10.921v-.417c-1.11-.021-1.868-.125-2.273-.312-.406-.187-.609-.582-.609-1.185v-3.059c1.954 0 3.427-.021 4.42-.064.993-.042 1.985-.165 2.978-.368 1.313-.288 2.255-.668 2.827-1.141.571-.472.856-.978.856-1.517 0-1.105-.728-1.884-2.185-2.338-1.458-.454-3.585-.681-6.382-.681H4.508v.417c1.068.058 1.788.168 2.162.33s.56.551.56 1.167v7.254c0 .582-.184.968-.552 1.157-.368.19-1.092.303-2.17.34v.417zm8.039-5.541V5.886c0-.224.141-.375.424-.452.283-.077.75-.116 1.402-.116 1.419 0 2.38.229 2.882.688s.753 1.063.753 1.81c0 1.094-.518 1.807-1.554 2.138-.651.208-1.953.32-3.907.336'
	    })
	  );
	};
	
	Logo.displayName = 'Logo';
	
	exports.default = (0, _styledComponents2.default)(Logo)(_templateObject);

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  text-transform: uppercase;\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    z-index: -1;\n    width: 100%;\n    height: 0;\n    left: 0;\n    bottom: ', ';\n    background-color: ', ';\n    transition: all 0.3s ease;\n  }\n\n  ', ';\n\n  @media (hover) {\n    &:hover::after {\n      height: 3px;\n    }\n  }\n'], ['\n  position: relative;\n  text-transform: uppercase;\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    z-index: -1;\n    width: 100%;\n    height: 0;\n    left: 0;\n    bottom: ', ';\n    background-color: ', ';\n    transition: all 0.3s ease;\n  }\n\n  ', ';\n\n  @media (hover) {\n    &:hover::after {\n      height: 3px;\n    }\n  }\n']);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _utils = __webpack_require__(6);
	
	var _vars = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MainNavLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, (0, _utils.pxToRem)(-5), _vars.COLORS.brand[1], function (_ref) {
	  var selected = _ref.selected;
	  return selected && '\n    &::after {\n      height: 3px;\n    }\n  ';
	});
	
	MainNavLink.displayName = 'styled(MainNavLink)';
	
	exports.default = MainNavLink;
	module.exports = exports['default'];

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MenuIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MenuIcon = exports.MenuIcon = function MenuIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '2.432 1.39 11.136 10.02' }, props),
	    _react2.default.createElement('path', { d: 'M9.561,7.2c0.441,0,0.8-0.358,0.8-0.8s-0.358-0.8-0.8-0.8H3.232c-0.442,0-0.8,0.358-0.8,0.8s0.358,0.8,0.8,0.8H9.561z' }),
	    _react2.default.createElement('path', {
	      d: 'M13.568,2.19c-0.002-0.441-0.359-0.798-0.801-0.8H3.232c-0.442,0-0.8,0.358-0.8,0.8s0.358,0.8,0.8,0.8h9.536 C13.208,2.985,13.562,2.63,13.568,2.19z'
	    }),
	    _react2.default.createElement('path', {
	      d: 'M3.232,11.41h4.167c0.442,0,0.8-0.358,0.8-0.801c0-0.441-0.358-0.799-0.8-0.799H3.232c-0.442,0-0.8,0.357-0.8,0.799 C2.432,11.052,2.79,11.41,3.232,11.41z'
	    })
	  );
	};
	
	MenuIcon.displayName = 'MenuIcon';
	
	exports.default = (0, _styledComponents2.default)(MenuIcon)(_templateObject);

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  height: ', ';\n  width: ', ';\n  margin-top: ', ';\n  margin-bottom: ', ';\n  position: relative;\n\n  &::after {\n    content: none;\n  }\n\n  ', ' {\n    display: block;\n  }\n'], ['\n  display: inline-block;\n  height: ', ';\n  width: ', ';\n  margin-top: ', ';\n  margin-bottom: ', ';\n  position: relative;\n\n  &::after {\n    content: none;\n  }\n\n  ', ' {\n    display: block;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  clip: rect(1px, 1px, 1px, 1px);\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: 0;\n'], ['\n  clip: rect(1px, 1px, 1px, 1px);\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: none;\n\n  @media (min-width: ', ') {\n    display: flex;\n  }\n\n  ', ' {\n    margin-bottom: 0;\n\n    &:not(:last-child) {\n      margin-right: ', ';\n    }\n  }\n'], ['\n  display: none;\n\n  @media (min-width: ', ') {\n    display: flex;\n  }\n\n  ', ' {\n    margin-bottom: 0;\n\n    &:not(:last-child) {\n      margin-right: ', ';\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: ', ';\n  bottom: 0;\n  background: white;\n  z-index: 999;\n  flex-direction: column;\n  padding: ', ';\n  font-size: ', ';\n  transition: transform 0.4s, box-shadow 0.4s;\n  transform: translateX(0);\n  box-shadow: 1px 1px 1rem rgba(0, 0, 0, 0.5);\n\n  &[aria-hidden=\'true\'] {\n    transform: translateX(-100%);\n    box-shadow: 1px 1px 1rem rgba(0, 0, 0, 0);\n  }\n\n  @media (min-width: ', ') {\n    font-size: ', ';\n  }\n\n  @media (min-width: ', ') {\n    display: none;\n  }\n\n  ', ' {\n    margin-right: 0;\n\n    &:not(:last-child) {\n      margin-bottom: 1rem;\n    }\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: ', ';\n  bottom: 0;\n  background: white;\n  z-index: 999;\n  flex-direction: column;\n  padding: ', ';\n  font-size: ', ';\n  transition: transform 0.4s, box-shadow 0.4s;\n  transform: translateX(0);\n  box-shadow: 1px 1px 1rem rgba(0, 0, 0, 0.5);\n\n  &[aria-hidden=\'true\'] {\n    transform: translateX(-100%);\n    box-shadow: 1px 1px 1rem rgba(0, 0, 0, 0);\n  }\n\n  @media (min-width: ', ') {\n    font-size: ', ';\n  }\n\n  @media (min-width: ', ') {\n    display: none;\n  }\n\n  ', ' {\n    margin-right: 0;\n\n    &:not(:last-child) {\n      margin-bottom: 1rem;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ' {\n    display: block;\n  }\n\n  ', ', ', ' {\n    fill: ', ';\n    width: ', ';\n    height: ', ';\n  }\n\n  ', ' {\n    stroke: ', ';\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      display: none;\n    }\n  }\n'], ['\n  ', ' {\n    display: block;\n  }\n\n  ', ', ', ' {\n    fill: ', ';\n    width: ', ';\n    height: ', ';\n  }\n\n  ', ' {\n    stroke: ', ';\n  }\n\n  @media (min-width: ', ') {\n    ', ' {\n      display: none;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HeaderBar = __webpack_require__(309);
	
	var _HeaderBar2 = _interopRequireDefault(_HeaderBar);
	
	var _FlatList = __webpack_require__(113);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	var _MenuIcon = __webpack_require__(314);
	
	var _MenuIcon2 = _interopRequireDefault(_MenuIcon);
	
	var _CloseIcon = __webpack_require__(129);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _Logo = __webpack_require__(312);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _MainNavLink = __webpack_require__(313);
	
	var _MainNavLink2 = _interopRequireDefault(_MainNavLink);
	
	var _InvisibleButton = __webpack_require__(121);
	
	var _InvisibleButton2 = _interopRequireDefault(_InvisibleButton);
	
	var _utils = __webpack_require__(6);
	
	var _vars = __webpack_require__(5);
	
	var _FlatListItem = __webpack_require__(114);
	
	var _FlatListItem2 = _interopRequireDefault(_FlatListItem);
	
	var _links = __webpack_require__(139);
	
	var _links2 = _interopRequireDefault(_links);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var logoOriginalHeight = 45;
	var logoSizeRatio = logoOriginalHeight / 197;
	var logoHeight = 50;
	var logoWidth = logoHeight / logoSizeRatio;
	var logoMarginDelta = (logoHeight - logoOriginalHeight) / 2 * -1;
	
	var LogoLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, (0, _utils.pxToRem)(logoHeight), (0, _utils.pxToRem)(logoWidth), (0, _utils.pxToRem)(logoMarginDelta), (0, _utils.pxToRem)(logoMarginDelta), _Logo2.default);
	
	var SiteTitle = _styledComponents2.default.h1(_templateObject2);
	
	var DesktopNav = (0, _styledComponents2.default)(_FlatList2.default)(_templateObject3, (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.navTransition), _FlatListItem2.default, (0, _utils.pxToRem)(30));
	
	var MobileNav = (0, _styledComponents2.default)(_FlatList2.default)(_templateObject4, (0, _utils.pxToRem)(60), (0, _utils.pxToRem)(_vars.GUTTER_SIZE), (0, _utils.pxToRem)(_vars.TYPE_SIZE.t4[0]), (0, _utils.pxToRem)(600), (0, _utils.pxToRem)(_vars.TYPE_SIZE.t3[0]), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.navTransition), _FlatListItem2.default);
	
	var PageHeaderBar = function (_React$Component) {
	  _inherits(PageHeaderBar, _React$Component);
	
	  function PageHeaderBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageHeaderBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { showMenu: false }, _this.mobileNav = _react2.default.createRef(), _this.handleShowMenu = function () {
	      // put focus into the mobile nav
	      _this.mobileNav.current.focus();
	      _this.setState({
	        showMenu: true
	      });
	    }, _this.handleHideMenu = function () {
	      _this.setState({
	        showMenu: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PageHeaderBar.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        currentPathname = _props.currentPathname;
	
	    return _react2.default.createElement(
	      _HeaderBar2.default,
	      { tag: 'nav', className: className },
	      _react2.default.createElement(
	        LogoLink,
	        { to: '/' },
	        _react2.default.createElement(
	          SiteTitle,
	          null,
	          'Priority Construction'
	        ),
	        _react2.default.createElement(_Logo2.default, null)
	      ),
	      _react2.default.createElement(
	        _InvisibleButton2.default,
	        {
	          onClick: this.state.showMenu ? this.handleHideMenu : this.handleShowMenu,
	          'aria-label': (this.state.showMenu ? 'Hide' : 'Show') + ' menu'
	        },
	        this.state.showMenu ? _react2.default.createElement(_CloseIcon2.default, null) : _react2.default.createElement(_MenuIcon2.default, null)
	      ),
	      _react2.default.createElement(
	        MobileNav,
	        { 'aria-hidden': !this.state.showMenu },
	        _react2.default.createElement(
	          _FlatListItem2.default,
	          null,
	          _react2.default.createElement('div', { ref: this.mobileNav, tabIndex: -1 }),
	          _react2.default.createElement(
	            _MainNavLink2.default,
	            {
	              selected: currentPathname === '/',
	              onClick: this.handleHideMenu,
	              to: '/',
	              tabIndex: !this.state.showMenu ? -1 : undefined
	            },
	            'Home'
	          )
	        ),
	        _links2.default.map(function (link) {
	          return _react2.default.createElement(
	            _FlatListItem2.default,
	            { key: link.children },
	            _react2.default.createElement(
	              _MainNavLink2.default,
	              {
	                selected: currentPathname === link.to,
	                to: link.to,
	                onClick: _this2.handleHideMenu,
	                tabIndex: !_this2.state.showMenu ? -1 : undefined
	              },
	              link.children
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        DesktopNav,
	        null,
	        _links2.default.filter(function (link) {
	          return link.desktop;
	        }).map(function (link) {
	          return _react2.default.createElement(
	            _FlatListItem2.default,
	            { key: link.children },
	            _react2.default.createElement(
	              _MainNavLink2.default,
	              {
	                selected: currentPathname === link.to,
	                to: link.to,
	                onClick: _this2.handleHideMenu
	              },
	              link.children
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return PageHeaderBar;
	}(_react2.default.Component);
	
	PageHeaderBar.propTypes = {
	  currentPathname: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	exports.default = (0, _styledComponents2.default)(PageHeaderBar)(_templateObject5, _InvisibleButton2.default, _MenuIcon2.default, _CloseIcon2.default, _vars.COLORS.brand[3], (0, _utils.pxToRem)(20), (0, _utils.pxToRem)(20), _CloseIcon2.default, _vars.COLORS.brand[3], (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.navTransition), _InvisibleButton2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Type2 = undefined;
	
	var _vars = __webpack_require__(5);
	
	var _typeComponentFactory = __webpack_require__(65);
	
	var _typeComponentFactory2 = _interopRequireDefault(_typeComponentFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var result = (0, _typeComponentFactory2.default)(_vars.TYPE_SIZE.t2, {
	  defaultTag: 'h2',
	  displayName: 'Type2'
	});
	
	var Type2 = exports.Type2 = result.Type;
	
	exports.default = result.StyledType;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Type4 = undefined;
	
	var _vars = __webpack_require__(5);
	
	var _typeComponentFactory = __webpack_require__(65);
	
	var _typeComponentFactory2 = _interopRequireDefault(_typeComponentFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var result = (0, _typeComponentFactory2.default)(_vars.TYPE_SIZE.t4, {
	  defaultTag: 'h4',
	  displayName: 'Type4'
	});
	
	var Type4 = exports.Type4 = result.Type;
	
	exports.default = result.StyledType;

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  to: '/services',
	  children: 'Services',
	  desktop: true
	}, {
	  to: '/about',
	  children: 'About',
	  desktop: true
	}, {
	  to: '/gallery',
	  children: 'Project Gallery',
	  desktop: true
	}, {
	  to: '/quote',
	  children: 'Request Quote',
	  footer: true
	}, {
	  to: '/careers',
	  children: 'Careers',
	  desktop: true
	}, {
	  to: '/contact',
	  children: 'Contact Us',
	  footer: true
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhFBMVEU4UHJPZIKLma3CydTIztiapreWorStt8Wfq7uJl6xzhJxAV3i3wMz////6+vs8U3XK0Nnp7PBKYH+os8KToLNkd5JBWHhRZoRsfZbh5eri5uuMma37/PyBkaZ/jqR9jaNvgJlVaYY5UXO4wc39/f1EW3tNY4GIlqq9xdDBydOdqbpxgpqREPopAAAAAWJLR0QN9rRh9QAAAAlwSFlzAAADKgAAAyoBEJdYGAAAAAd0SU1FB+ILEwERKiuEWbgAAABcSURBVBjTrc9XDkBQEIXhwdUdvffOZf/7kxBlAf63+ZLzMER/JIgSY0xWVE03zIsswCZyXMDzTwhOoBBA9ECcpBnygm4oq7ppu57oO3kbgHF6z3lZOefb/ssPVwehcAVNnnK+lgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0xMS0xOVQwMToxNzo0MiswMTowMH7PYsYAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMTEtMTlUMDE6MTc6NDIrMDE6MDAPktp6AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAFd6VFh0UmF3IHByb2ZpbGUgdHlwZSBpcHRjAAB4nOPyDAhxVigoyk/LzEnlUgADIwsuYwsTIxNLkxQDEyBEgDTDZAMjs1Qgy9jUyMTMxBzEB8uASKBKLgDqFxF08kI1lQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAwFBMVEU4UHJ3iJ+Jl6yHlap+jqR2hp5sfpdkdpFTZ4U5UXNabop9jaObp7jk6Oz///+4wc2Mma2BkaaToLOqtMPr7vH09ffP1N2ossFWaodsfZb6+vs9VXa0vcr7/PyptMJRZoRAV3j29/nU2eHBydM7U3Tz9fefq7v9/v67w889VHVBWHhidZBzg5uEk6i8xM/s7/JQZYPM0tvK0NnIz9jGzdfEy9WxusiYpLZ/jqRleJJMYoDl6O3X3OOVorR6iqF6iqBvrPQhAAAAAWJLR0QOb70wTwAAAAlwSFlzAAAGVAAABlQBxPCNnQAAAAd0SU1FB+ILEwERK1yDaS4AAACZSURBVDjLY2AYBTDAyIQMmFlY2dg5OJEVcHHz8PJBAL+AoJCwCJAhKiYugaxGEiIvBeZIy4A5snLSCAXyyAoYFBQhXG5cChiUIFxlXApUVCFcNVwKmMEcdQ1NTAVa8to6unogpr6aAbIvoArUDY2MTUyVzcwtLFVQwwrNkZiADgrYoHFhhVUWGFnWUAU2tnZchKLbnmEUYAEACsARwKDF3HkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTEtMTlUMDE6MTc6NDMrMDE6MDDYuGlyAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTExLTE5VDAxOjE3OjQzKzAxOjAwqeXRzgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII="

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  @media (min-width: ', ') {\n    ', ' {\n      background-color: ', ';\n    }\n  }\n\n  ', ' {\n    margin-bottom: 0.5rem;\n  }\n\n  ', ', ', ' {\n    text-shadow: 0 0 2px\n      ', ';\n  }\n'], ['\n  @media (min-width: ', ') {\n    ', ' {\n      background-color: ', ';\n    }\n  }\n\n  ', ' {\n    margin-bottom: 0.5rem;\n  }\n\n  ', ', ', ' {\n    text-shadow: 0 0 2px\n      ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  @media (min-width: ', ') {\n    .hero-image-left {\n      .gatsby-image-outer-wrapper {\n        width: 50%;\n      }\n    }\n  }\n'], ['\n  ', ';\n\n  @media (min-width: ', ') {\n    .hero-image-left {\n      .gatsby-image-outer-wrapper {\n        width: 50%;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _memoizeOne = __webpack_require__(336);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _base = __webpack_require__(317);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _Footer = __webpack_require__(304);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Hero = __webpack_require__(134);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _HeroHomePageContent = __webpack_require__(310);
	
	var _HeroHomePageContent2 = _interopRequireDefault(_HeroHomePageContent);
	
	var _HeroWithBanner = __webpack_require__(311);
	
	var _HeroWithBanner2 = _interopRequireDefault(_HeroWithBanner);
	
	var _PageHeaderBar = __webpack_require__(315);
	
	var _PageHeaderBar2 = _interopRequireDefault(_PageHeaderBar);
	
	var _Type = __webpack_require__(291);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _Type3 = __webpack_require__(71);
	
	var _Type4 = _interopRequireDefault(_Type3);
	
	var _Button = __webpack_require__(61);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Head = __webpack_require__(308);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _vars = __webpack_require__(5);
	
	var _mixins = __webpack_require__(123);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// eslint-disable-next-line no-unused-expressions
	(0, _styledComponents.injectGlobal)(_templateObject, _base2.default);
	
	var StyledHeroHomePageContent = (0, _styledComponents2.default)(_HeroHomePageContent2.default)(_templateObject2, (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL), _HeroHomePageContent.StyledContentWrapper, _vars.COLORS.brand[0], _Type2.default, _Type2.default, _Type4.default, (0, _tinycolor2.default)(_vars.COLORS.brand[1]).darken(30).toRgbString());
	
	var getConfigFromPathname = function getConfigFromPathname(configs, pathname) {
	  var path = pathname.replace('/', '');
	  return _extends({}, configs.base, configs[path]);
	};
	
	/* eslint-disable react/sort-comp, react/no-unused-state */
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.pageConfigs = {
	      base: {
	        background: _this.props.data.backgroundHome,
	        isFullHeight: false,
	        heroChildren: null,
	        title: ''
	      },
	      '': {
	        isFullHeight: true,
	        heroChildren: _react2.default.createElement(
	          StyledHeroHomePageContent,
	          { innerTag: 'hgroup' },
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true },
	            'Bringing Concrete Ideas to Life'
	          ),
	          _react2.default.createElement(
	            _Type4.default,
	            { tag: 'p' },
	            'Quality workmanship & excellent customer service'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { color: 'light', large: true, tag: _gatsbyLink2.default, to: '/services' },
	            'Our services'
	          )
	        ),
	        className: 'hero-image-left'
	      },
	      services: {
	        background: _this.props.data.backgroundServices,
	        isFullHeight: true,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'Services' }),
	        title: 'Services',
	        imgStyle: {
	          objectPosition: 'bottom center'
	        }
	      },
	      quote: {
	        background: _this.props.data.backgroundRequestQuote,
	        isFullHeight: true,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'Request a Quote' }),
	        title: 'Request a Quote'
	      },
	      about: {
	        background: _this.props.data.backgroundAbout,
	        isFullHeight: true,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'About Us' }),
	        title: 'About Us',
	        imgStyle: {
	          objectPosition: 'top center'
	        }
	      },
	      careers: {
	        background: _this.props.data.backgroundCareers,
	        isFullHeight: true,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'Career Opportunities' }),
	        title: 'Career Opportunities'
	      },
	      contact: {
	        isFullHeight: false,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'Contact Us' }),
	        title: 'Contact Us'
	      },
	      gallery: {
	        background: _this.props.data.backgroundGallery,
	        heroChildren: _react2.default.createElement(_HeroWithBanner2.default, { title: 'Project Gallery' }),
	        title: 'Project Gallery'
	      }
	    }, _this.layout = (0, _memoizeOne2.default)(function (pathname) {
	      return getConfigFromPathname(_this.pageConfigs, pathname);
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        className = _props.className;
	    var _data$site$siteMetada = data.site.siteMetadata,
	        title = _data$site$siteMetada.title,
	        desc = _data$site$siteMetada.desc,
	        keywords = _data$site$siteMetada.keywords,
	        address = _data$site$siteMetada.address,
	        phone = _data$site$siteMetada.phone;
	
	
	    var layout = this.layout(this.props.location.pathname);
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_Head2.default, {
	        title: '' + title + (layout.title ? ': ' + layout.title : ''),
	        description: desc,
	        keywords: keywords.join(', ')
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(_PageHeaderBar2.default, { currentPathname: this.props.location.pathname }),
	          _react2.default.createElement(
	            _Hero2.default,
	            {
	              selectedImage: layout.background,
	              bgImages: Object.keys(this.props.data).filter(function (key) {
	                return key !== 'site';
	              }).reduce(function (acc, key) {
	                acc.push(_this2.props.data[key]);
	                return acc;
	              }, []),
	              isFullHeight: layout.isFullHeight,
	              imgStyle: layout.imgStyle,
	              className: layout.className
	            },
	            layout.heroChildren
	          ),
	          children()
	        ),
	        _react2.default.createElement(_Footer2.default, _extends({}, address, { phone: phone }))
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.displayName = 'Layout';
	Layout.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        desc: _propTypes2.default.string,
	        keywords: _propTypes2.default.arrayOf(_propTypes2.default.string),
	        address: _propTypes2.default.shape({
	          streetAddress: _propTypes2.default.string.isRequired,
	          city: _propTypes2.default.string.isRequired,
	          state: _propTypes2.default.string.isRequired,
	          zip: _propTypes2.default.number.isRequired
	        }),
	        phone: _propTypes2.default.string.isRequired
	      })
	    }),
	    backgroundHome: CustomPropTypes.ImageSharp,
	    backgroundAbout: CustomPropTypes.ImageSharp,
	    backgroundGallery: CustomPropTypes.ImageSharp,
	    backgroundCareers: CustomPropTypes.ImageSharp,
	    backgroundServices: CustomPropTypes.ImageSharp,
	    backgroundRequestQuote: CustomPropTypes.ImageSharp
	  }).isRequired,
	  location: CustomPropTypes.Location.isRequired,
	  className: _propTypes2.default.string
	};
	exports.default = (0, _styledComponents2.default)(Layout)(_templateObject3, (0, _mixins.siteBg)(), (0, _utils.pxToRem)(_vars.MEDIA_QUERIES.heroL));
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(6);
	
	var _mixins = __webpack_require__(123);
	
	var _vars = __webpack_require__(5);
	
	exports.default = '\n@import url(\'' + _vars.FONT_URL + '\');\n\n  html {\n    box-sizing: border-box;\n    background-color: ' + _vars.COLORS.bg + ';\n  }\n\n  *, *::before, *::after {\n    box-sizing: inherit;\n  }\n\n  html {\n    ' + (0, _mixins.baseFont)() + ';\n    color: ' + _vars.COLORS.base + ';\n    font-size: 100%;\n  }\n\n  body {\n    margin: 0;\n    font-size: ' + (0, _utils.pxToRem)(16) + ';\n    line-height: ' + _vars.scaler * 1.05 + ';\n    font-weight: ' + _vars.BODY_WEIGHTS.regular + ';\n  }\n\n  input, textarea, select, button {\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    color: inherit;\n\n    &:focus {\n      outline-color: ' + _vars.COLORS.brand[3] + ';\n      outline-width: ' + (0, _utils.pxToRem)(3) + ';\n    }\n  }\n\n  label,\n  input[type=button],\n  input[type=submit],\n  input[type=reset],\n  button {\n    cursor: pointer;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    ' + (0, _mixins.headerFont)() + ';\n    font-weight: ' + _vars.BODY_WEIGHTS.regular + ';\n    line-height: 1.1;\n  }\n\n  h1, h2, h3, h4, h5, h6, p {\n    margin-top: 0;\n    margin-bottom: 1rem;\n  }\n\n  a {\n    position: relative;\n    display: inline-block;\n    background-color: transparent;\n    color: ' + _vars.COLORS.link + ';\n    text-decoration: none;\n    -webkit-tap-highlight-color: transparent;\n\n    &::after {\n      content: \'\';\n      position: absolute;\n      z-index: -1;\n      width: 100%;\n      height: 0.1875em;\n      left: 0;\n      bottom: 0;\n      background-color: ' + _vars.COLORS.brand[1] + ';\n    }\n  }\n\n  abbr {\n    position: relative;\n    text-decoration: none;\n\n    &::after {\n      content: \'\';\n      position: absolute;\n      z-index: -1;\n      width: 100%;\n      height: ' + (0, _utils.pxToRem)(2) + ';\n      left: 0;\n      bottom: ' + (0, _utils.pxToRem)(-3) + ';\n      background-color: ' + _vars.COLORS.base + ';\n      opacity: 0.3;\n    }\n  }\n\n  img, svg {\n    max-width: 100%;\n    height: auto;\n  }\n\n  img {\n    vertical-align: middle;\n    border: 0;\n  }\n\n  blockquote {\n    margin: 0;\n  }\n\n  hr {\n    border-width: 1px 0 0 0;\n    border-style: solid;\n  }\n\n  address {\n    font-style: normal;\n  }\n\n  fieldset {\n    border: none;\n    padding: 0;\n    margin: 0;\n  }\n';
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3c99a967bc4d4721d08e.js